import { Model, fk, many, attr } from "redux-orm";
import { NaeSSchemaMap } from "../config/NaeSSchema";

class ChallengeLessonModel extends Model {
  static reducer(action, ChallengeLessonModel, session) {
    switch (action.type) {
      case "UPSERT_" + NaeSSchemaMap.ChallengeLesson.schema:
        action.payload.forEach((payload) => {
          const dbData = ChallengeLessonModel.withId(payload.id);

          const upsertData = payload;
          if (dbData) {
            const keys = Object.keys(upsertData);
            let needChange = false;
            keys.map((key) => {
              if (
                JSON.stringify(upsertData[key]) !== JSON.stringify(dbData[key])
              ) {
                needChange = true;
              }
            });

            if (!needChange) {
              return;
            }
          }

          ChallengeLessonModel.upsert(payload);
        });
        break;
    }
    // Return value is ignored.
    return session.state;
  }

  toString() {
    return this.id;
  }
  // Declare any static or instance methods you need.
}
ChallengeLessonModel.modelName = "ChallengeLessonModel";

ChallengeLessonModel.fields = {
  id: attr(),
};

export default ChallengeLessonModel;